import { useTheme } from '@mui/material';

export const SuccessTickIcon = () => {
    const theme = useTheme();
    const primaryStroke = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="122"
            height="122"
            viewBox="0 0 122 122"
            fill="none"
        >
            <path
                opacity="0.1"
                d="M58.7136 87.5835L32.3088 62.9873C31.9021 62.6084 32.3245 61.9482 32.8389 62.1586L56.7678 71.9477C58.2674 72.5612 59.9891 72.2094 61.1278 71.0568L92.2276 39.5777C92.6441 39.1562 93.3178 39.6809 93.0112 40.1878L64.8626 86.7268C63.549 88.8986 60.5708 89.3135 58.7136 87.5835Z"
                fill={primaryStroke}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M61 117C91.9279 117 117 91.9279 117 61C117 56.9751 116.575 53.0494 115.769 49.2652C118.098 61.9783 116.014 75.657 108.895 87.8021C93.3806 114.271 59.8273 123.433 33.9515 108.266C8.07571 93.0987 -0.323854 59.3465 15.1905 32.8779C25.8886 14.6263 45.1639 4.60384 64.5847 5.11289C63.3995 5.03801 62.2042 5 61 5C30.0721 5 5 30.0721 5 61C5 91.9279 30.0721 117 61 117Z"
                fill={primaryStroke}
            />
            <circle opacity="0.2" cx="61" cy="61" r="60.5" stroke={primaryStroke} />
            <path
                d="M55.8623 68.8447L28.9922 57.6154L55.9794 72.6965C57.6283 73.6179 59.6971 73.2603 60.941 71.8387L85.332 43.9633C85.7377 43.4997 86.4594 44.0371 86.1316 44.5586L63.0091 81.3445C61.716 83.4016 58.9025 83.8402 57.0446 82.2743L29.8691 59.3692L57.0057 84.1799C58.8537 85.8694 61.7821 85.465 63.103 83.3379L91.9088 36.9492C92.2242 36.4414 91.5439 35.9084 91.1263 36.3362L60.267 67.9481C59.1214 69.1217 57.3755 69.477 55.8623 68.8447Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
